import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n              ", "\n            "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/core';
import GlobalTheme from '@atlaskit/theme/components';
import { getBackground } from './utils';
import { getSVGStyles, getSizeStyles } from './styles';
var PrimitiveSVGIcon = /*#__PURE__*/memo(function PrimitiveSVGIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      label = _ref.label,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      testId = _ref.testId,
      children = _ref.children;
  return jsx(GlobalTheme.Consumer, null, function (_ref2) {
    var mode = _ref2.mode;
    return jsx("svg", {
      viewBox: "0 0 24 24",
      css: [getSVGStyles({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || getBackground(mode)
      }), css(_templateObject(), getSizeStyles({
        size: size
      }))],
      "data-testid": testId,
      "aria-label": label,
      role: "presentation",
      children: children
    });
  });
});
export default PrimitiveSVGIcon;